import templatePolyfill from 'template-polyfill';
templatePolyfill();
